import React from 'react';
import ReactDOM from 'react-dom/client';

import '@aph/common-react/dist/style.css';

import { SearchFormType } from 'global.types';

import LibrarySearchInterface from './LibrarySearchInterface';

(window as any).mount = (id: string) => {
  const container = document.getElementById(id) as HTMLElement;

  if (!container.dataset?.selectedForm) {
    // eslint-disable-next-line no-console
    console.error('Missing required parameter: Form type; Add this parameter to the Sitecore parameter template; It must be a one of the selected type: "publications" | "legislation" | "statistics" | "lectures"');

    return;
  }

  if (!container.dataset?.sitecoreApiBaseUrl) {
    // eslint-disable-next-line no-console
    console.error('Missing required parameter: SitecoreApiBaseUrl; Add this parameter to the Sitecore parameter template');

    return;
  }

  ReactDOM.createRoot(container).render(
    <React.StrictMode>
      <LibrarySearchInterface
        searchFormType={container.dataset.selectedForm as SearchFormType}
        sitecoreApiBaseUrl={container.dataset.sitecoreApiBaseUrl}
        additionalContent={container.dataset?.licenceContent}
      />
    </React.StrictMode>
  );
};
